import React from 'react';

const TABS = [
  { view: 'dashboard', icon: '\u{1F3E0}', label: 'Home' },
  { view: 'csv-upload', icon: '\u{1F4E4}', label: 'Upload' },
  { view: 'daily-overview', icon: '\u{1F4C5}', label: 'Tage' },
  { view: 'analytics', icon: '\u{1F4CA}', label: 'Analysen' },
  { view: 'data-quality', icon: '\u2705', label: 'Qualit\u00E4t' },
];

function BottomNav({ activeView, onViewChange }) {
  return (
    <nav className="bottom-nav" aria-label="Mobile Navigation">
      {TABS.map(tab => (
        <button
          key={tab.view}
          className={`bottom-nav-item ${activeView === tab.view ? 'active' : ''}`}
          onClick={() => onViewChange(tab.view)}
          aria-current={activeView === tab.view ? 'page' : undefined}
        >
          <span className="bottom-nav-icon">{tab.icon}</span>
          <span className="bottom-nav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
